"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MapmakerConfig_dev_1 = __importDefault(require("./MapmakerConfig.dev"));
const config = Object.assign(Object.assign({}, MapmakerConfig_dev_1.default), { stage: "local", isLocal: true, apiGateway: {
        // If you are debugging on a device just set the "Port Forwarding" options in Chrome. No need to
        // change this URLs.
        url: "http://localhost:4032",
    } });
exports.default = config;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJDb25maWcubG9jYWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvTWFwbWFrZXJDb25maWcubG9jYWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSw4RUFBdUM7QUFHdkMsTUFBTSxNQUFNLG1DQUNQLDRCQUFHLEtBQ04sS0FBSyxFQUFFLE9BQU8sRUFDZCxPQUFPLEVBQUUsSUFBSSxFQUNiLFVBQVUsRUFBRTtRQUNWLGdHQUFnRztRQUNoRyxvQkFBb0I7UUFDcEIsR0FBRyxFQUFFLHVCQUF1QjtLQUM3QixHQUNGLENBQUM7QUFFRixrQkFBZSxNQUFNLENBQUMifQ==